var _circle, _path;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLightbulb(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 17,
    cy: 17,
    r: 16.5,
    fill: "#81D61E",
    stroke: "#DBDBDB"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.25 25.25C14.25 25.7542 14.6625 26.1667 15.1667 26.1667H18.8333C19.3375 26.1667 19.75 25.7542 19.75 25.25V24.3333H14.25V25.25ZM17 7.83333C13.4617 7.83333 10.5833 10.7117 10.5833 14.25C10.5833 16.4317 11.6742 18.3475 13.3333 19.5117V21.5833C13.3333 22.0875 13.7458 22.5 14.25 22.5H19.75C20.2542 22.5 20.6667 22.0875 20.6667 21.5833V19.5117C22.3258 18.3475 23.4167 16.4317 23.4167 14.25C23.4167 10.7117 20.5383 7.83333 17 7.83333ZM19.6125 18.0083L18.8333 18.5583V20.6667H15.1667V18.5583L14.3875 18.0083C13.15 17.1467 12.4167 15.7442 12.4167 14.25C12.4167 11.72 14.47 9.66667 17 9.66667C19.53 9.66667 21.5833 11.72 21.5833 14.25C21.5833 15.7442 20.85 17.1467 19.6125 18.0083Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLightbulb);
export default __webpack_public_path__ + "static/media/lightbulb.010c4bea32e97c0152a3eb7f70641b65.svg";
export { ForwardRef as ReactComponent };